import styled from 'styled-components';

import { colors } from 'constants/colors';

import { GetDeliveryQuery } from 'data/__generated__';

import { SectionColumn, SectionContainer, ColumnsSectionContainer } from 'components/DetailsView/Section';
import { DetailValue } from 'components/DetailsView/DetailValue';

import { getTimeFromDatetime } from '../../../helpers/dateTimes';
import { DetailLink } from 'components/DetailsView';

export const DriverSection = ({ delivery }: { delivery: NonNullable<GetDeliveryQuery['delivery']> }) => {
    const {
        deliveryPerson,
        roundColor,
        roundName,
        serviceTime,
        theoricServiceTime,
        times: {
            preferenceSlot: { start: startTimePreference, end: endTimePreference },
            actualSlot: { start: actualStartTime, end: actualEndTime },
        },
        trackingUrl,
    } = delivery;

    const roundBackgroundColor = roundColor || colors.pantinGrey;

    return (
        <SectionContainer title="Informations de livraison" isInitiallyOpen>
            <ColumnsSectionContainer numberOfColumns={2}>
                <SectionColumn>
                    <SubsectionTitle>Livraison</SubsectionTitle>
                    <DetailValue
                        label="Lien de suivi"
                        value={
                            trackingUrl ? (
                                <UrbantzLink target="_blank" rel="noopener noreferrer" href={trackingUrl ?? ''}>
                                    {trackingUrl}
                                </UrbantzLink>
                            ) : (
                                'Non défini'
                            )
                        }
                    />
                    <DetailValue
                        label="Tournée"
                        value={
                            <RoundContainer $backgroundColor={roundBackgroundColor}>
                                {roundName || 'Pas de tournée associée'}
                            </RoundContainer>
                        }
                    />
                    {deliveryPerson ? (
                        <DetailLink
                            label="Livreur"
                            path="user"
                            name={
                                deliveryPerson.profile.lastname || deliveryPerson.profile.firstname
                                    ? `${deliveryPerson.profile.lastname ?? ''} ${deliveryPerson.profile.firstname ?? ''}`.trim()
                                    : (deliveryPerson.profile.fullname ?? deliveryPerson.username)
                            }
                            value={deliveryPerson._id}
                        />
                    ) : (
                        <DetailValue label="Livreur" value="Non défini" />
                    )}
                    <DetailValue
                        label="Créneau de livraison"
                        value={
                            startTimePreference && endTimePreference
                                ? `Entre ${getTimeFromDatetime(new Date(startTimePreference))} et ${getTimeFromDatetime(
                                      new Date(endTimePreference),
                                  )}`
                                : 'Pas de préférence'
                        }
                    />
                    <DetailValue
                        label="Date d'arrivée"
                        value={actualStartTime ? getTimeFromDatetime(new Date(actualStartTime)) : 'Non défini'}
                    />
                    <DetailValue
                        label="Date de clôture"
                        value={actualEndTime ? getTimeFromDatetime(new Date(actualEndTime)) : 'Non défini'}
                    />
                </SectionColumn>
                <SectionColumn>
                    <SubsectionTitle>Temps de service</SubsectionTitle>
                    <DetailValue
                        label="Prévu"
                        value={theoricServiceTime !== null ? `${theoricServiceTime} min` : 'Non défini'}
                    />
                    <DetailValue label="Effectif" value={`${serviceTime} min`} />
                    {delivery.siteSetup ? (
                        <DetailLink
                            label="Rangement Totops"
                            path="site-setup"
                            name="Lien"
                            value={delivery.siteSetup._id}
                        />
                    ) : null}
                </SectionColumn>
            </ColumnsSectionContainer>
        </SectionContainer>
    );
};

const SubsectionTitle = styled.span`
    font-size: 22px;
    font-weight: 800;
    color: ${({ theme }) => theme.textColor};
`;

const RoundContainer = styled.div<{ $backgroundColor: string }>`
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    color: ${colors.pureWhite};
    font-weight: 800;
    padding: 5px;
    border-radius: ${({ theme }) => theme.borderRadius};
    text-align: center;
`;

const UrbantzLink = styled.a`
    color: ${colors.green};
`;
